import { render } from "./realEstateBulletinDetails.vue?vue&type=template&id=2855fd6c"
import script from "./realEstateBulletinDetails.vue?vue&type=script&lang=js"
export * from "./realEstateBulletinDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__